const Validators = {
  required: {
    name: 'required',
    validate: (value) => {
      return value !== undefined && value !== null
    },
    error: 'This field is required'
  },
  integer: {
    name: 'integer',
    validate: (value) => {
      return !!(Number.isInteger(value))
    },
    error: `This field must be an integer`
  },
  date: {
    name: 'date',
    validate: (value) => {
      const dateRegex = /(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})/

      return !!(!value || value.match(dateRegex))
    },
    error: `This field must be a valid date`
  },
  email: {
    name: 'email',
    validate: (value) => {
      const emailRegex = /[^@ \t\r\n]+@[^@ \t\r\n]+\.[^@ \t\r\n]+/

      return !!(!value || value.match(emailRegex))
    },
    error: 'This field must be a valid email'
  },
  minLength: (parameter) => {
    return {
      name: 'minLength',
      parameter,
      validate: (value) => {
        return !!(value && value.length && value.length >= parameter)
      },
      error: `This field must be at least ${parameter} characters long`
    }
  },
  maxLength: (parameter) => {
    return {
      name: 'maxLength',
      parameter,
      validate: (value) => {
        return !!(value && value.length && value.length <= parameter)
      },
      error: `This field mustn't be longer than ${parameter} characters`
    }
  },
  min: (parameter) => {
    return {
      name: 'min',
      parameter,
      validate: (value) => {
        return !!(Number.isInteger(value) && value >= parameter)
      },
      error: `This field must be at least ${parameter}`
    }
  },
  max: (parameter) => {
    return {
      name: 'max',
      parameter,
      validate: (value) => {
        return !!(Number.isInteger(value) && value <= parameter)
      },
      error: `This field mustn't be higher than ${parameter}`
    }
  },
  multiple: (parameter) => {
    return {
      name: 'multiple',
      parameter,
      validate: (value) => {
        return !!(Number.isInteger(value) % parameter === 0)
      },
      error: `This field must be a multiple of ${parameter}`
    }
  }
}

export default Validators
